import { all, put, select, takeEvery, call } from "redux-saga/effects";
import _ from "lodash";
import { modules } from 'veritone-redux-common';
import { getListStationApi } from "../../../helpers/stationApi";
import {
    addCampaignApi,
    getCampaignApi,
    removeCampaignApi,
    updateCampaignApi,
    removeCreativeApi,
    undoCreativeApi,
    updateCampaignDrilldownApi,
    getDataDrillDownChangingApi,
    getCampaignLastMentionApi,
    getCampaignHashHistoryApi, getCalculatedPercentage
} from "../../../helpers/campaignApi";
import { getDataDrillDownApi } from "../../../helpers/chartApi";
import {
    ADD_CAMPAIGN_SAGA,
    DUPLICATE_CAMPAIGN_SAGA,
    addCampaign,
    duplicateCampaign,
    GET_CAMPAIGN_SAGA,
    GET_DETAIL_STATION_SAGA,
    getCampaign,
    loadCampaign,
    updateChartDataCampaign,
    loadChartDataCampaign,
    NEXT_STEP_CAMPAIGN_SAGA,
    REMOVE_CAMPAIGN_SAGA,
    REMOVE_CREATIVE_SAGA,
    removeCampaign,
    setStep,
    UPDATE_CAMPAIGN_SAGA,
    UPDATE_CHART_DATA_CAMPAIGN_SAGA,
    getCampaignByAdvertiserId,
    updateCampaign,
    loadChartDataCampaignSaga,
    undoCreativeName,
    UNDO_CREATIVE_NAME_SAGA,
    UPDATE_SUMMARY_DRILL_DOWN_SAGA,
    GET_DATA_DRILL_DOWN_SAGA,
    updateDataDrillDown,
    removeChartData,
    UNDO_UPDATE_DATA_DRILLDOWN_SAGA,
    loadSummaryDrilldown,
    MOVE_BACK_REASSIGN_SAGA,
    LOAD_ADPERFORMANCE_CHART_DATA_SAGA,
    updateAdperformanceChartData,
    changeLoadingStatus,
    LOAD_CAMPAIGN_DETAIL_SAGA,
    updateCampaignDetailLoadingStatus,
    LOAD_CAMPAIGN_PROGRESS_BAR_STATUS_SAGA
} from "./campaign";
import {
    selectGeoFencing,
    updateGeoSelected,
    updateCountryLoadedStatus
} from '../app/geoSelector/actions'

import * as GeofenceActions from '../app/geoSelector/actions';

import { chooseCampaign, updateAdvertiserStatus } from "./advertiser"
import { checkCampaignError, validateFindAdsData, validateStations } from '../../../helpers/validate';
import constants, {
    SHOW_TOAST_ACTIONS,
    CAMPAIGN_GEOFENCING_TAB,
    CAMPAIGN_FIND_ADS_TAB,
    CAMPAIGN_SELECT_STATIONS_TAB,
    GA_CHART_ID,
    AD_PERFORMANCE_CHART_ID,
    DAYPART_COMPILATION_CHART_ID,
    ADVISIT_CHART_ID,
    GEO_CHART_ID,
    BETA_FEATURES,
    CHARTS_IN_TAB,
    DEFAULT_CAMPAIGN_TAB,
    MAXIMUM_DURATION_DAYS_DEFAULT,
    DEFAULT_CAMPAIGN_CHART_IDS,
    STATION_CHART_ID,
    ADTYPE_CHART_ID,
    KEYWORD_CHART_ID,
    OTHER_TRAFFIC_CHANNEL_ID,
    PAGE_PATH_CHART_ID,
    DEVICE_CATEGORY_CHART_ID,
    TRAFFIC_CHANNEL_CHART_ID,
    CREATIVE_CHART_ID,
    ADVISIT_BY_DAY_OF_WEEK_CHART_ID
} from '../../../helpers/constant';
import { getChartDataKey, checkObjDiffByProps, convertTimezoneDate, resetNewAdUserChartSelector } from '../../../helpers/formatData';
import { 
    formatChartData, 
    convertDataChartId1, 
    convertDataForDaypartCompilationChart, 
    convertDataForGeoChart, 
    convertDataForCreativeChart,
    prepGeoData,
    getCampaignDateInfo,
    getFormatedSummaryCampaignData,
    getFormattedChartData
} from "../../../components/DashboardTab/preprocessData";
import {
    getChartData,
    getStationChartData,
    getAdTypeChartData,
    getChartDataWebAnalyticsCompare,
    getAggregateGeofencingData,
    getPerformanceSummaryChartData,
    getCampaignSummaryData,
    getPagePathChartData,
    getDeviceCategoryChartData,
    getTrafficChanelChartData,
    getCreativeChartData,
    getDayPartChartData,
    getAdVisitByWeekChartData
} from "../../../helpers/chartApi";
import { ROUTE_HOME } from "modules/routing";
import { showToast, showToastWithAction } from "./notification";
import { calAdperformanceRange, defaultAdperformanceRangeValue } from "components/AdsPerformance/util";
import { getRangeBeforeCampaign } from "components/DatePicker/constants";
import { QueueSingleton } from '../../../helpers/QueueManager';
import { 
    setCampaignChartData, 
    ActionType as CampaignAction, 
    setGeoLocationChildren, 
    setGeoLoadingStatus,
    Status,
    setCampaignProgressBarStatus
} from '../app/campaign/actions';
import { updateCampaignPermissions } from '../../../state/modules/app/campaign/actions';
import { removeVisualRefreshDataSaga } from "./visualDataRefresh";
import { DEFAULT_TIME_ZONE_KEY } from '../../../components/TimeZoneSelector/constants';
import { getAdvertiser } from '../app/advertiser';
import { getGA4PropertyId, shouldShowTileByDateCompare } from '../../../helpers/common';
import moment from 'moment';
import { CSPToV3Query } from 'veritone-csp-generator';
import { searchBarApi } from "../../../helpers/searchBarApi";

const payloadCampaignKeys = [
    'campaign_id',
    'campaign_name',
    'start_date',
    'end_date',
    'advertiser_id',
    'id',
    'name',
    'startDate',
    'endDate',
    'advertiserId',
    'ownerId',
    'custom_date_range',
    'editors',
    'viewers',
    'selectedTrafficChannels',
    'creativeMapping',
    'timezoneSetting',
    'liveRead',
    'stationList',
    'locationSelected',
    'unratedLocationSelected',
    'include_undefined_location',
    'selectionType',
    'geoType',
    'watchList',
    'preRecorded',
    'watchlistMaximumDurationDays'
  ];

const campaignPropsToGetNewChartData = ['timezoneSetting'];

const {
    config: { getConfig },
    user: { hasFeature, selectUser }
} = modules;

export function validateCampaign(campaign, campaigns) {
    const { activeStep } = campaign;
    switch (activeStep) {
        case 0:
            return checkCampaignError(campaign, campaigns);
        case 1:
            return validateStations(campaign);
        case 2:
            return validateFindAdsData(campaign);
        default:
            return "";
    }
}

function* getStationSaga(action) {
    const { campaign } = action.payload;
    const config = yield select(getConfig);
    let offset = 0;
    const LIMIT = 100;
    const RETRY_MAX = 10;
    const SOURCE_TYPE_IDS = [1, 2];
    let retry = 0;
    let stations = [];
    let stationResult = null;

    yield put(loadCampaign(campaign.campaign_id, {
        loading: true,
        loaded: false
    }));

    while (!stationResult || (stationResult.length === LIMIT && retry < RETRY_MAX)) {
        stationResult = yield getListStationApi(config.urlApi, SOURCE_TYPE_IDS, LIMIT, offset);
        offset = offset + LIMIT;
        retry = retry + 1;
        stations = [...stations, ...stationResult];
    }

    const getCampaignNew = yield select(getCampaign);
    const advertiserNew = getCampaignNew("editing");
    const stationList = _.get(campaign, "stationList");
    let updatingStations = null;
    if (stationList) {
        const stationMap = stationList
            .filter(station => station.checked)
            .reduce((cum, station) => ({ ...cum, [station.stationId]: station }), {});
        updatingStations = stations.map(station => ({
            stationId: station.id,
            stationName: station.name,
            sourceTypeId: station.sourceTypeId,
            checked: !!stationMap[station.id]
        }));
    } else {
        updatingStations = stations.map(station => ({
            stationId: station.id,
            stationName: station.name,
            sourceTypeId: station.sourceTypeId,
            checked: true
        }));
    }
    yield put(updateCampaign({
        ...advertiserNew,
        stationList: updatingStations,
        stationLoading: false
    }));

    yield put(loadCampaign(campaign.campaign_id, {
        loading: false,
        loaded: true
    }));
}

export function* removeCampaignSaga(action) {
    const { campaign, isShowToast = true } = action.payload;
    const { rerouteCampaignId } = campaign;
    const config = yield select(getConfig);
    yield put(loadCampaign(campaign.campaign_id, {
        loading: true,
        loaded: false
    }));
    const campaignDetail = yield getCampaignApi(config.urlApi, campaign.campaign_id);
    const data = yield removeCampaignApi(config.urlApi, campaign.campaign_id);
    if (data.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        return yield put(showToast(toast));
    }
    // delete watchlist in liveRead and pre-recorded
    yield put(removeCampaign(campaignDetail));
    if(!rerouteCampaignId) {
        yield put({ type: ROUTE_HOME });
    } else {
        const { advertiser_id } = campaign;
        yield put({
            type: 'route/ROUTE_CAMPAIGN_TABS',
            payload: {
                advertiserId: advertiser_id,
                campaignId: rerouteCampaignId,
                tab: DEFAULT_CAMPAIGN_TAB
            }
        })
    }
    const toast = {
        message: "Campaign deleted",
        action: "Dismiss",
        type: constants.SUCCESS
    };
    isShowToast && (yield put(showToast(toast)));
}

function* addCampaignSaga(action) {
    const { campaign } = action.payload;
    const config = yield select(getConfig);
    const geoFencing = yield select(selectGeoFencing);
    const state = yield select();
    const getAdvertiserById = getAdvertiser(state);
    const advertiser = getAdvertiserById(campaign.advertiser_id);
    const isGA4Advertiser = !!getGA4PropertyId(advertiser);
    const currentUser = selectUser(state);
    const watchlistMaximumDurationDays = _.get(currentUser, 'organization.kvp.features.watchlistLimits.maximumDurationDays', MAXIMUM_DURATION_DAYS_DEFAULT);
    // set state loading for adding advertiser
    yield put(loadCampaign("editing", {
        loading: true,
        loaded: false
    }));

    const { selectedIds, includeUnidentifiedLocation, selectionType, unratedIds = []} = geoFencing;
    const createCampaignResult = yield addCampaignApi(config.urlApi, {
        ...campaign,
        locationSelected: isGA4Advertiser ? [] : selectedIds,
        'include_undefined_location': isGA4Advertiser ? true : includeUnidentifiedLocation,
        selectionType,
        unratedLocationSelected: isGA4Advertiser ? [] : unratedIds,
        watchlistMaximumDurationDays,
        selectedTrafficChannels: isGA4Advertiser ? [OTHER_TRAFFIC_CHANNEL_ID] : campaign.selectedTrafficChannels
    });
    if (createCampaignResult.error) {
        const toast = {
            message: "Something went wrong creating a Campaign",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
        return;
    }
    yield put(updateGeoSelected({}, {}));
    yield put(updateCountryLoadedStatus(false));
    const toast = {
        message: "New campaign added",
        action: "Dismiss",
        type: constants.SUCCESS
    }
    const { campaign_id, advertiser_id } = createCampaignResult;
    yield put(showToast(toast));
    yield put(addCampaign(createCampaignResult));
    yield put(chooseCampaign(advertiser_id, campaign_id))
    //redirect to advertiser detail page
    yield put({
        type: 'route/ROUTE_CAMPAIGN_TABS',
        payload: {
            advertiserId: advertiser_id,
            campaignId: campaign_id,
            tab: DEFAULT_CAMPAIGN_TAB
        }
    })
}

function* duplicateCampaignSaga(action) {
    const { campaign } = action.payload;
    const { viewers, editors } = campaign;
    const config = yield select(getConfig);
    const state = yield select();
    const getAdvertiserById = getAdvertiser(state);
    const currentUser = selectUser(state);
    const watchlistMaximumDurationDays = _.get(currentUser, 'organization.kvp.features.watchlistLimits.maximumDurationDays', MAXIMUM_DURATION_DAYS_DEFAULT);
    // set state loading for adding advertiser
    yield put(loadCampaign("editing", {
        loading: true,
        loaded: false
    }));
    const ttwnAndPremiere = _.get(campaign, 'ttwnAndPremiere', {});
    // in case of selecting only ttwn stations in iheart org, stationList might be not returned in campaign
    const stationList = _.get(campaign, 'stationList', []);
    const createCampaignResult = yield addCampaignApi(config.urlApi, {
        ...campaign,
        watchlistMaximumDurationDays,
        isDuplicated: true,
        stationList,
        ...ttwnAndPremiere,
    });
    if (createCampaignResult.error) {
        const toast = {
            message: "Something went wrong duplicating the Campaign",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(showToast(toast));
        return;
    }
    yield put(updateGeoSelected({}, {}));
    yield put(updateCountryLoadedStatus(false));
    const toast = {
        message: "Duplicate campaign added",
        action: "Dismiss",
        type: constants.SUCCESS
    }
    const { campaign_id, advertiser_id } = createCampaignResult;
    yield put(showToast(toast));
    const newCampaignData = {
        ...createCampaignResult,
        viewers,
        editors
    };
    yield put(duplicateCampaign(newCampaignData));
    const advertiser = getAdvertiserById(advertiser_id);
    advertiser.campaigns = [...advertiser.campaigns, newCampaignData]
    yield put(updateAdvertiserStatus(advertiser));
    yield put(chooseCampaign(advertiser_id, campaign_id));
    //redirect to advertiser detail page
    yield put({
        type: 'route/ROUTE_CAMPAIGN_TABS',
        payload: {
            advertiserId: advertiser_id,
            campaignId: campaign_id,
            tab: DEFAULT_CAMPAIGN_TAB
        }
    })
}

function* updateCampaignSaga(action) {
    const { campaign, oldCampaign } = action.payload;
    let { activeStep, campaign_id, advertiser_id } = campaign;
    const config = yield select(getConfig);
    const geoFencing = yield select(selectGeoFencing);
    const state = yield select();
    const getAdvertiserById = getAdvertiser(state);
    const advertiser = getAdvertiserById(campaign.advertiser_id);
    const isGA4Advertiser = !!getGA4PropertyId(advertiser);
    const currentUser = selectUser(state);
    const watchlistMaximumDurationDays = _.get(currentUser, 'organization.kvp.features.watchlistLimits.maximumDurationDays', MAXIMUM_DURATION_DAYS_DEFAULT);
    // validate campaign
    const getListCampaign = yield select(getCampaignByAdvertiserId);
    const campaigns = getListCampaign(advertiser_id);
    const errMsg = validateCampaign(campaign, campaigns);
    if (errMsg) {
        return yield put(updateCampaign({
            ...campaign,
            campaign_id: "editing",
            errMsg  
        }));
    }

    yield put(updateCampaign(
        {
            ...campaign,
            campaign_id: "editing",
            loading: true,
            loaded: false
        }
    ))

    const {
        selectedIds,
        includeUnidentifiedLocation,
        selectionType,
        unratedIds = []
    } = geoFencing;

    let rqSelectedTrafficChannels, rqLocationSelected, rqIncludeUndefinedLocation, rqUnratedLocationSelected;
    if (isGA4Advertiser) {
        rqSelectedTrafficChannels = oldCampaign.selectedTrafficChannels;
        rqLocationSelected = oldCampaign.locationSelected;
        rqIncludeUndefinedLocation = oldCampaign.include_undefined_location;
        rqUnratedLocationSelected = oldCampaign.unratedLocationSelected;
    } else {
        rqSelectedTrafficChannels = campaign.selectedTrafficChannels;
        rqLocationSelected = selectedIds;
        rqIncludeUndefinedLocation = includeUnidentifiedLocation;
        rqUnratedLocationSelected = unratedIds;
    }

    const newCampaign = {
        ...campaign,
        locationSelected: rqLocationSelected,
        'include_undefined_location': rqIncludeUndefinedLocation,
        selectionType,
        unratedLocationSelected: rqUnratedLocationSelected,
        watchlistMaximumDurationDays,
        selectedTrafficChannels: rqSelectedTrafficChannels,
    }
    const payloadCampaign = _.pick(newCampaign, payloadCampaignKeys);
    let updatingCampaign = yield updateCampaignApi(config.urlApi, payloadCampaign);
    if (updatingCampaign.error) {
        const message = _.get(updatingCampaign,
            "response.data.message.advertiser.running",
            "Something went wrong updating an Campaign");
        const toast = {
            message,
            action: "Dismiss",
            type: constants.FAILED
        };
        return yield put(showToast(toast));
    }
    const { start_date: startDate, end_date: endDate } = updatingCampaign;
    const { start_date: prevStartDate, end_date: prevEndDate } = oldCampaign;
    const selectedRange = {
        start: startDate,
        end: endDate
    }
    updatingCampaign = {
        ...campaign,
        ...updatingCampaign,
        masterCalendar: { selected: selectedRange, value: -1 },
        firstCalendar: { selected: selectedRange, value: -1 },
        secondCalendar: { selected: getRangeBeforeCampaign(selectedRange), value: -1 },
    }
    
    const isDateRangeChanged = !moment(startDate).isSame(prevStartDate) || !moment(endDate).isSame(prevEndDate);
    const shouldChartDataReplaced = isDateRangeChanged || checkObjDiffByProps(oldCampaign, updatingCampaign, campaignPropsToGetNewChartData);
    //if true, we remove current chartData, CampaignPage will take care to get new chart
    if (shouldChartDataReplaced) {
        updatingCampaign = {
            ...updatingCampaign,
            chartData: {}
        }
    }
    //Update campaign
    yield put(updateCampaign( updatingCampaign, oldCampaign));
    //Update campaign 'editing'
    yield put(updateCampaign(
        {
            ...campaign,
            campaign_id: 'editing',
            loading: true,
            loaded: false
        }
    ));
    yield put(updateAdvertiserStatus(advertiser));
    const toast = {
        message: "Campaign Updated",
        action: "Dismiss",
        type: constants.SUCCESS
    };

    yield put(showToast(toast));
    _.isNumber(activeStep) && (yield put({
        type: "route/ROUTE_CAMPAIGN_TABS",
        payload: {
            advertiserId: advertiser_id,
            campaignId: campaign_id,
            tab: DEFAULT_CAMPAIGN_TAB
        }
    }));

    yield put(loadCampaign("editing", {
        loading: false,
        loaded: true
    }));

    return {
        ...updatingCampaign,
    }
}

function* getCampaignSaga(action) {
    const { campaignId, currentTab } = action.payload;
    //set step for campaign
    let newActiveStep;
    switch(currentTab) {
        case CAMPAIGN_SELECT_STATIONS_TAB:
            newActiveStep = 1;
            break;
        case CAMPAIGN_FIND_ADS_TAB:
            newActiveStep = 2;
            break;
        case CAMPAIGN_GEOFENCING_TAB:
            newActiveStep = 3;
            break;
        default:
            newActiveStep = 0;
            break;
    }

    // get campaign detail from store
    const getCampaignNew = yield select(getCampaign);

    let res = getCampaignNew(campaignId);
    let detail = {};
    if (res.detailLoadingStatus !== "loaded") {
        detail = yield call(loadCampaignDetailSaga, {
            payload: {
                campaignId
            }
        })
    }
    if (detail.error) {
        return
    }
    res = {...res, ...detail};
    
    //update selected locations
    const state = yield select();
    const isOnBetaFeature = yield hasFeature(state, 'beta');
    const isGeoFencingDisable = isOnBetaFeature && _.includes(BETA_FEATURES, "GeoFencing");
    if (!isGeoFencingDisable) {
        const selectedIds = _.get(res, 'locationSelected', []);
        const includeUnidentifiedLocation = _.get(res, 'include_undefined_location', true);
        const selectionType = _.get(res, 'selectionType', 'location');
        const unratedIds = _.get(res, 'unratedLocationSelected', []);
        yield put(GeofenceActions.setSelection({
                selectedIds,
                selectionType,
                hasNewRegion: true,
                includeUnidentifiedLocation,
                unratedIds
            })
        );
    }

    yield put(addCampaign({
        ...res,
        campaign_id: "editing",
        loading: false,
        loaded: true,
        activeStep: newActiveStep,
        detailLoadingStatus: 'loaded'
    }));
}

function* updateCampaignChartData(action) {
    const config = yield select(getConfig);
    const state = yield select();
    const currentUser = selectUser(state);

    // NOTE: keep this for reference of beta features
    // const isNotOnBetaFeature = _.get(currentUser, "organization.kvp.features.beta") !== "enabled";
    
    const attributeAppConfig = _.get(currentUser, 'organization.kvp.features.attribute') || {};
    const isAdSourcesEnabled = _.get(attributeAppConfig, 'displayAdSourcesFilter') === "enabled";
    const showKeywordTable = _.get(attributeAppConfig, 'keywordReport') === "enabled";
    const isNewAdUserEnabled = _.get(currentUser, 'organization.kvp.features.attribute.newAdUsersMetric') === "enabled";
    const { advertiser, campaign, isOverride } = action.payload;
    const advertiserId = _.get(advertiser, 'advertiser_id');
    const campaign_id = _.get(campaign, 'campaign_id');
    const {
        campaignStartDate,
        campaignEndDate,
        startMaster,
        endMaster,
        startDateMaster,
        endDateMaster,
        startDateTimeSecondary,
        endDateTimeSecondary,
        startDateAdperformance,
        endDateAdperformance
    } = getCampaignDateInfo(campaign);

    if(!campaignStartDate && !campaignEndDate) {
      return;
    }
  
    //Set campaign status to loading
    yield put(loadCampaign(campaign_id, {loading: true, loaded: false}));
    const timezoneKey = _.get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
    const campaignId = campaign_id > 0 ? campaign_id : 0;

    const rangeObject = { start: startMaster, end: endMaster, timezone: timezoneKey };
    const rangeKey = getChartDataKey({ range: rangeObject });
    let campaignSelectedAdSources = _.get(campaign, 'selectedAdSources');
    const campaignAvailableAdSources = _.get(campaign, ['availableAdSources', rangeKey], []);

    //get campaignSummaryData
    let campaignSummaryData = {};
    if (campaignId) {
        campaignSummaryData = yield getCampaignSummaryData(
          config.urlApi,
          campaignId,
          startDateMaster,
          endDateMaster,
          campaignSelectedAdSources
        );
    }

    //find adsource list, this might be the available adsource from campaign itself or the adsource list user select from UI
    const availableAdSources = _.get(campaignSummaryData, 'adSources', []).sort();
    campaignSelectedAdSources = campaignSelectedAdSources || availableAdSources;
    const sortedAvailableAdSources = [...availableAdSources].sort();
    const sortedCampaignSelectedAdSources = [...campaignSelectedAdSources].sort();
    const sortedCampaignAvailableAdSources = [...campaignAvailableAdSources].sort();
    //compare if old campaignSelectedAdSources equal to new availableAdsources
    const adSourcesToQuery = _.isEqual(sortedAvailableAdSources, sortedCampaignSelectedAdSources) || !_.isEqual(sortedAvailableAdSources, sortedCampaignAvailableAdSources) ? null : campaignSelectedAdSources;
    const newSelectedAdsources = _.isEqual(sortedAvailableAdSources, sortedCampaignAvailableAdSources) ? sortedCampaignSelectedAdSources : sortedAvailableAdSources;
    
    const chartKeyWithAdSources = getChartDataKey({ 
      range: rangeObject, 
      selectedAdSources: newSelectedAdsources
    });
    const chartKey = isAdSourcesEnabled ? chartKeyWithAdSources : rangeKey;
    const formattedSummaryData = getFormatedSummaryCampaignData(campaignSummaryData);
    const { geoType } = formattedSummaryData;

    //Update campaign info
    const newCampaign = {
      ...campaign,
      geoType,
      availableAdSources: {
          ...campaign.availableAdSources,
          [rangeKey]: availableAdSources
      },
      selectedAdSources: isAdSourcesEnabled ? newSelectedAdsources : undefined,
      chartData: {
        ...campaign.chartData,
        [chartKey]:{
            ...formattedSummaryData,
            startDate: startDateMaster,
            endDate: endDateMaster
        }
      },
    };

    // Replace newAdUser chart selector if the new range doesn't include new ad user data (UA data)
    const isShowTileByDateCompare = shouldShowTileByDateCompare({advertiser, campaign});
    if( isNewAdUserEnabled && !isShowTileByDateCompare ){
        newCampaign.chartSelector = resetNewAdUserChartSelector(newCampaign.chartSelector);
    }
    
    //Save common campaign info to redux
    const newCampaignData = isOverride ? {...newCampaign, chartData:{}} : newCampaign;
    yield put(updateChartDataCampaign(newCampaignData));

    // Put charts in queue
    const clonedChartTabs = _.cloneDeep(CHARTS_IN_TAB);
    const currentTab = _.get(state, 'location.payload.tab', DEFAULT_CAMPAIGN_TAB);
    clonedChartTabs[currentTab] && delete clonedChartTabs[currentTab];
    const chartIdsQueue = [currentTab, ...Object.keys(clonedChartTabs)];
    
    for( let i = 0; i < chartIdsQueue.length; i++) {
        const tabKey = chartIdsQueue[i];
        const chartIds = CHARTS_IN_TAB[tabKey];
        QueueSingleton.enqueue(chartIds, tabKey);
    }

    // Load charts
    while(QueueSingleton.queue.length > 0) {
        const currentQueue = QueueSingleton.dequeue();
        if (currentQueue) {
            const getCampaignInfo = yield select(getCampaign);
            const currentCampaign = getCampaignInfo(campaignId);
            if (currentCampaign && !_.isEmpty(currentCampaign)) {
                const data = yield loadChartData(config.urlApi, currentQueue.task);
                yield put(setCampaignChartData(data, campaignId, chartKey));
            }
        }
    }

    async function loadChartData(urlApi, chartIds =[]) {
        let chartIdsToProcess = chartIds.reduce((acc, id) => {
            if (id == KEYWORD_CHART_ID && !showKeywordTable){
                return acc;
            }
            acc.push(id);
            return acc;
        }, []);
        const rawData = await Promise.all(chartIdsToProcess.map(id=> {
            const formatChartId = parseInt(id);
            const payload = {
              urlApi,
              advertiserId,
              campaignId,
              chartId: id,
              startDate: startDateMaster,
              endDate: endDateMaster,
              adSources: adSourcesToQuery,
            };

            switch (formatChartId) {
                case AD_PERFORMANCE_CHART_ID:
                    return getPerformanceSummaryChartData(
                        urlApi,
                        advertiserId,
                        campaignId,
                        id,
                        startDateMaster,
                        endDateMaster,
                        startDateAdperformance,
                        endDateAdperformance,
                        adSourcesToQuery
                    );
                case GEO_CHART_ID:
                    return getAggregateGeofencingData(payload);
                case GA_CHART_ID:
                    return getChartDataWebAnalyticsCompare(
                        config.urlApi,
                        advertiserId,
                        campaignId,
                        GA_CHART_ID,
                        startDateMaster,
                        endDateMaster,
                        startDateTimeSecondary,
                        endDateTimeSecondary,
                        adSourcesToQuery
                    );
                case KEYWORD_CHART_ID:
                    return getChartData(payload);
                    
                case STATION_CHART_ID:
                    return getStationChartData(payload);

                case ADTYPE_CHART_ID:
                    return getAdTypeChartData(payload);
                    
                case DEVICE_CATEGORY_CHART_ID:
                    return getDeviceCategoryChartData(payload);

                case PAGE_PATH_CHART_ID:
                    return getPagePathChartData(payload);
              
                case TRAFFIC_CHANNEL_CHART_ID:
                    return getTrafficChanelChartData(payload);

                case CREATIVE_CHART_ID:
                   return getCreativeChartData(payload);
                
                case DAYPART_COMPILATION_CHART_ID: 
                    return getDayPartChartData(payload);

                case ADVISIT_BY_DAY_OF_WEEK_CHART_ID:
                    return getAdVisitByWeekChartData(payload);

                default:
                    return getChartData(payload);
            }
        }));
        const formattedChartData = getFormattedChartData(rawData, campaign, chartIdsToProcess);
        return formattedChartData;
    }

    // Done
    yield put(loadCampaign(campaign_id, {
        loading: false,
        loaded: true
    }));
}


function* removeCreativeSaga(action) {
    const { advertiser, campaign, creative } = action.payload

    const { campaign_id } = campaign
    const dateRange = ""
    const config = yield select(getConfig);
    const results = yield removeCreativeApi(config.urlApi, campaign_id, creative)
    if (results.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(undoCreativeName(campaign_id, false))
        return yield put(showToast(toast));
    }
    yield put(undoCreativeName(campaign_id, true))
    const getCampaignNew = yield select(getCampaign);
    const newCampaign = yield getCampaignNew(campaign_id)
    yield put(loadChartDataCampaignSaga(advertiser, newCampaign, dateRange));
}

function* undoCreativeSaga(action) {
    const { advertiser, campaign, creative } = action.payload
    const { campaign_id } = campaign
    const dateRange = ""
    const config = yield select(getConfig);
    const results = yield undoCreativeApi(config.urlApi, campaign_id, creative)
    if (results.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(undoCreativeName(campaign_id, false))
        return yield put(showToast(toast));
    }
    yield put(undoCreativeName(campaign_id, false))
    const getCampaignNew = yield select(getCampaign);
    const newCampaign = yield getCampaignNew(campaign_id)
    yield put(loadChartDataCampaignSaga(advertiser, newCampaign, dateRange));
}

function* nextStepSaga(action) {
    // set next step for add campaign and edit campaign
    const { campaign } = action.payload;
    const { advertiser_id, activeStep } = campaign;
    const getListCampaign = yield select(getCampaignByAdvertiserId);
    const campaigns = getListCampaign(advertiser_id);
    const errMsg = validateCampaign(campaign, campaigns);
    if (errMsg) {
        return (
            yield put(updateCampaign({
                ...campaign,
                errMsg
            }))
        );
    }
    yield put(setStep(activeStep + 1));
}

function* moveBackReassign(action) {
    const {
        campaign,
        advertiser,
        reassignMentionsList,
        excludeMentionList,
        paramGetData,
        summaryJobTitle = ""
    } = action.payload;
    const config = yield select(getConfig);
    const drilldown = {
        "exclude": excludeMentionList,
        "reassign": reassignMentionsList,
        "title_job": summaryJobTitle
    }
    yield put(loadSummaryDrilldown(campaign.campaign_id, {loading: true, loaded: false}));
    const results = yield updateCampaignDrilldownApi(config.urlApi, campaign.campaign_id, drilldown);
    if(results.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(loadSummaryDrilldown(campaign.campaign_id, {loading: false, loaded: true}));
        return yield put(showToast(toast));
    }
    const dateRange = ""
    let newCampaign = _.omit(campaign, 'dataDrillDown');
    yield put(loadChartDataCampaignSaga(advertiser, newCampaign, dateRange));
    
    yield getDataDrillDownSaga({payload: {
        campaignId: paramGetData.campaignId,
        isUrlChange: false,
        drilldownInfo: paramGetData
    }});
    const toast = {
        message: summaryJobTitle,
        action: "Dismiss",
        type: constants.SUCCESS
    };
    yield put(showToast(toast));
}

function* loadAdperformanceChartDataSaga(action) {
    const { campaignId, advertiserId, adPerformanceRange } = action.payload;
    const config = yield select(getConfig);

    const {
        startCampaign,
        endCampaign,
        startDateAdperformance,
        endDateAdperformance,
        rangeMaster,
        rangeAdperformance
    } = adPerformanceRange;
    yield put(changeLoadingStatus(campaignId, AD_PERFORMANCE_CHART_ID, "loading"));
    const results = yield getPerformanceSummaryChartData(
        config.urlApi,
        advertiserId,
        campaignId,
        AD_PERFORMANCE_CHART_ID,
        startCampaign,
        endCampaign,
        startDateAdperformance,
        endDateAdperformance
    );
    if (results.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(changeLoadingStatus(campaignId, AD_PERFORMANCE_CHART_ID, "fail"));
        return yield put(showToast(toast));
    }
    const data = _.get(results, "data", {});
    yield put(updateAdperformanceChartData(
        campaignId,
        rangeMaster,
        {[rangeAdperformance]: {data}}
    ))
    yield put(changeLoadingStatus(campaignId, AD_PERFORMANCE_CHART_ID, "loaded"));
}

function* updateSummaryDrillDownSaga(action) {
    const {
        excludeMentionList,
        reassignMentionsList,
        campaign,
        advertiser,
        messageSnackbar,
        mentionsToReassign,
        paramGetData
    } = action.payload;
    const {
        includeJobTitleMessage,
        excludeJobTitleMessage,
        reassignJobTitleMessage
    } = action.payload.summaryJobTitle;
    const { dataMentions, frozenExcludeList, frozenReassignList } = campaign.dataDrillDown;
    const config = yield select(getConfig);
    const drilldown = {
        "exclude": excludeMentionList,
        "reassign": reassignMentionsList,
        "title_job": includeJobTitleMessage + excludeJobTitleMessage + reassignJobTitleMessage
    }
    yield put(loadSummaryDrilldown(campaign.campaign_id, {loading: true, loaded: false}));
    const results = yield updateCampaignDrilldownApi(config.urlApi, campaign.campaign_id, drilldown);
    if (results.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(loadSummaryDrilldown(campaign.campaign_id, {loading: false, loaded: true}));
        return yield put(showToast(toast));
    }
    yield put(removeChartData(campaign.campaign_id));
    const dateRange = ""
    let newCampaign = _.omit(campaign, 'dataDrillDown');
    yield put(loadChartDataCampaignSaga(advertiser, newCampaign, dateRange));

    if (mentionsToReassign.length) {
        
        yield getDataDrillDownSaga({payload: {
            campaignId: paramGetData.campaignId,
            isUrlChange: false,
            drilldownInfo: paramGetData
        }});
    } else {
        let newDataDrillDownMentions = dataMentions.map(mention => {
            if (excludeMentionList.includes(mention.gen_key)) {
                return {
                    ...mention,
                    status: 2
                }
            }
            return {
                    ...mention,
                    status: 1
                }
        })
        yield put(updateDataDrillDown(
            newDataDrillDownMentions,
            dataMentions,
            excludeMentionList,
            frozenExcludeList,
            reassignMentionsList,
            frozenReassignList,
            campaign.campaign_id));
        yield put(loadSummaryDrilldown(campaign.campaign_id, {loading: false, loaded: true}));
    }
    yield put(showToastWithAction(
        SHOW_TOAST_ACTIONS.SUMMARY_DRILL_DOWN,
        messageSnackbar
    ))
}

export function* getDataDrillDownSaga(action) {
    const config = yield select(getConfig);
    const { campaignId, isUrlChange, drilldownInfo } = action.payload;
    yield put(loadSummaryDrilldown(campaignId, {loading: true, loaded: false}));
    const dataDrillDownMentionsResult = yield getDataDrillDownApi(
        config.urlApi,
        campaignId,
        drilldownInfo
        );
    const dataDrillDownChangingResult = yield getDataDrillDownChangingApi(config.urlApi, campaignId);
    const currentState = yield select();
    const currentDataDrillDown = _.get(currentState, ["campaign","byId", `${campaignId}`,"dataDrillDown"], {});
    let responseExcludeList = [];
    let responseReassignList = [];
    dataDrillDownChangingResult.data.map(item => {
        if (item.criteria_name === "exclude") {
            responseExcludeList = _.uniq(item.criteria_value)
        }
        if (item.criteria_name === "reassign") {
            responseReassignList = item.criteria_value.reduce((groupList, list) => {
                    /* eslint lodash/matches-shorthand: [2, "never"] */
                    let groupOfList = _.find(groupList, item => item.assignTo.toCreativeName === list.toCreativeName &&  item.assignTo.creative_duration === list.creative_duration);

                    if (groupOfList) {
                        groupOfList.gen_key = _.union(groupOfList.gen_key, list.from)
                        return groupList
                    }
                    return [...groupList, {
                        "gen_key": list.from,
                        "assignTo": {
                            "toCreativeName": list.toCreativeName,
                            "type": list.type,
                            "creative_duration": list.creative_duration
                        }
                    }]
                }, [])
        }
    })
    let frozenExcludeList = isUrlChange ? responseExcludeList : _.get(currentDataDrillDown, "frozenExcludeList", responseExcludeList);
    let frozenReassignList = isUrlChange ? responseReassignList : _.get(currentDataDrillDown, "frozenReassignList", responseReassignList);
    let frozenDataMentions = isUrlChange ? dataDrillDownMentionsResult : _.get(currentDataDrillDown, "frozenDataMentions", dataDrillDownMentionsResult);
    yield put(updateDataDrillDown(
        dataDrillDownMentionsResult,
        frozenDataMentions,
        responseExcludeList,
        frozenExcludeList,
        responseReassignList,
        frozenReassignList,
        campaignId))

    yield put(loadSummaryDrilldown(campaignId, {loading: false, loaded: true}))
}

function* undoUpdateDrillDownSaga(action) {
    const { frozenDataMentions, frozenExcludeList, frozenReassignList, campaign, advertiser } = action.payload;
    const {
        includeJobTitleMessage,
        excludeJobTitleMessage,
        reassignJobTitleMessage
    } = action.payload.summaryJobTitle;
    const undoMessage = (includeJobTitleMessage.length ? ("Undo: " + includeJobTitleMessage) : "") +
            (excludeJobTitleMessage.length ? ("Undo: " + excludeJobTitleMessage) : "") +
            (reassignJobTitleMessage.length ? ("Undo: " + reassignJobTitleMessage) : "");
    const drilldown = {
        "exclude": frozenExcludeList,
        "reassign": frozenReassignList,
        "title_job": undoMessage
    }
    const config = yield select(getConfig);
    yield put(loadSummaryDrilldown(campaign.campaign_id, {loading: true, loaded: false}));
    const result = yield updateCampaignDrilldownApi(config.urlApi, campaign.campaign_id, drilldown);
    if (result.error) {
        return yield put(loadSummaryDrilldown(campaign.campaign_id, {loading: false, loaded: false}));
    }
    yield put(updateDataDrillDown(
        frozenDataMentions,
        frozenDataMentions,
        frozenExcludeList,
        frozenExcludeList,
        frozenReassignList,
        frozenReassignList,
        campaign.campaign_id))

    const undoCampaign = {
        ...campaign,
        dataDrillDown: {
            ...campaign.dataDrillDown,
            dataMentions: frozenDataMentions,
            excludeMentionList: frozenExcludeList,
            reassignMentionsList: frozenReassignList
        }
    }

    yield put(removeChartData(campaign.campaign_id));
    const dateRange = ""
    yield put(loadChartDataCampaignSaga(advertiser, undoCampaign, dateRange));
    yield put(loadSummaryDrilldown(campaign.campaign_id, {loading: false, loaded: true}));
}

function* loadCampaignDetailSaga(action) {
    const { campaignId } = action.payload;
    const config = yield select(getConfig);
    yield put(updateCampaignDetailLoadingStatus(campaignId, "loading"));
    let res = yield getCampaignApi(config.urlApi, campaignId);
    if (res.error) {
        const toast = {
            message: "Something went wrong",
            action: "Dismiss",
            type: constants.FAILED
        };
        yield put(updateCampaignDetailLoadingStatus(campaignId, "fail"));
        return yield put(showToast(toast));
    }

    // save campaign detail
    yield put(updateCampaign(res));
    yield put(updateCampaignDetailLoadingStatus(campaignId, "loaded"));
    return res;
}

function* loadGeoFenceDataSaga(action) {
    const { campaign, locationIds, dateRange } = action.payload;
    const campaignId = _.get(campaign, 'campaign_id');
    yield put(setGeoLoadingStatus(Status.LOADING, campaignId, dateRange));
    const state = yield select();
    const config = yield select(getConfig);
    const currentUser = selectUser(state);
    const isAdSourcesEnabled = _.get(currentUser, 'organization.kvp.features.attribute.displayAdSourcesFilter') === "enabled";
    const campaignStartDate = _.get(campaign, 'start_date');
    const campaignEndDate = _.get(campaign, 'end_date');
    const startMaster = _.get(campaign, 'masterCalendar.selected.start') || campaignStartDate;
    const endMaster = _.get(campaign, 'masterCalendar.selected.end') || campaignEndDate;
    const timezoneKey = _.get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
    const startDateMaster = convertTimezoneDate(startMaster, timezoneKey, true);
    const endDateMaster = convertTimezoneDate(endMaster, timezoneKey, false);
    const selectedAdSources = isAdSourcesEnabled && _.get(campaign, 'selectedAdSources');
    const targetLocationId = _.last(locationIds);
    const responds = yield getAggregateGeofencingData({
        urlApi: config.urlApi, 
        campaignId, 
        startDate: startDateMaster, 
        endDate: endDateMaster, 
        adSources: selectedAdSources, 
        location: targetLocationId});
    const geoData = _.get(responds, 'data');
    if (geoData) {
        const processdGeoData = prepGeoData(geoData);
        yield put(setGeoLocationChildren(processdGeoData, campaignId, locationIds, dateRange));
        yield put(setGeoLoadingStatus(Status.LOADED, campaignId, dateRange));
    } else {
        const toast = {
            message: "Failed to get geo location data",
            action: "Dismiss",
            type: constants.FAILED
        };
        return yield put(showToast(toast));
    }
}

function* loadGeoFenceByLocationPathSaga(action) {
    try {
        const { campaign, locationIds, dateRange } = action.payload;
        const campaignId = _.get(campaign, 'campaign_id');
        yield put(setGeoLoadingStatus(Status.LOADING, campaignId, dateRange));
        const state = yield select();
        const config = yield select(getConfig);
        const currentUser = selectUser(state);
        const isAdSourcesEnabled = _.get(currentUser, 'organization.kvp.features.attribute.displayAdSourcesFilter') === "enabled";
        const campaignStartDate = _.get(campaign, 'start_date');
        const campaignEndDate = _.get(campaign, 'end_date');
        const startMaster = _.get(campaign, 'masterCalendar.selected.start') || campaignStartDate;
        const endMaster = _.get(campaign, 'masterCalendar.selected.end') || campaignEndDate;
        const timezoneKey = _.get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
        const startDateMaster = convertTimezoneDate(startMaster, timezoneKey, true);
        const endDateMaster = convertTimezoneDate(endMaster, timezoneKey, false);
        const selectedAdSources = isAdSourcesEnabled && _.get(campaign, 'selectedAdSources');
        const geoData = _.get(campaign, ['chartData', dateRange, GEO_CHART_ID, 'data'], {});
        
        if (!startMaster || !endMaster) {
            return;
        }
        
        const currentLocationPath = [];
        let currentLocationData = _.get(geoData, [locationIds[0]], {});
        for (let index = 0, lastIndex = locationIds.length; index < lastIndex; index++) {
            currentLocationPath.push(locationIds[index]);
            const isLoaded = _.get(currentLocationData, 'status') === Status.LOADED;
            if (isLoaded) {
                continue;
            }
            const responds = yield getAggregateGeofencingData({
                urlApi: config.urlApi, 
                campaignId, 
                startDate: startDateMaster, 
                endDate: endDateMaster, 
                adSources: selectedAdSources, 
                location: locationIds[index]
            });
            const geoData = _.get(responds, 'data');
            if (geoData) {
                const processedGeoData = prepGeoData(geoData);
                yield put(setGeoLocationChildren(processedGeoData, campaignId, [...currentLocationPath], dateRange));
            } else {
                const toast = {
                    message: "Failed to get geo location data",
                    action: "Dismiss",
                    type: constants.FAILED
                };
                return yield put(showToast(toast));
            }
            currentLocationData = _.get(currentLocationData, ['children', locationIds[index + 1]], {});
        }
        yield put(setGeoLoadingStatus(Status.LOADED, campaignId, dateRange));
    } catch (error) {
        console.log(error);
    }
}

function* loadCampaignProgressBarStatusSaga(action) {
    const { campaign, advertiser, sessionToken } = action.payload;
    const paramSearch = _.get(campaign, 'preRecorded.paramSearch');
    let results = [];
    const config = yield select(getConfig);
    if(typeof paramSearch !== undefined && paramSearch){
        let searchQuery = CSPToV3Query(paramSearch);
        searchQuery.query.conditions.push({
            'operator': 'terms',
            'field': 'mediaSourceId',
            'values': campaign.stationList
        });
        if (campaign.startDate && campaign.endDate) {
            searchQuery.query.conditions.push({
            'operator': 'range',
            'field': 'absoluteStartTimeMs',
            'gte': campaign.startDate
            });
            searchQuery.query.conditions.push({
            'operator': 'range',
            'field': 'absoluteStopTimeMs',
            'lte': campaign.endDate
            });
        }
    
        searchQuery = { ...searchQuery, ...{ index: ['mine'], limit: 1, offset: 0 } };
        results = yield searchBarApi(config.urlApi, searchQuery, sessionToken)    
    }

    let percentComplete = 0;
    let lastSdoDate;
    if(results.length >= 1){
        lastSdoDate = results[0].recording.absoluteStopTimeMs
    }
    let endDates = []
    // Add last SDO date if exist for pre-recorded campaigns
    if(lastSdoDate){
      endDates.push(new Date(lastSdoDate))
    }
    // Add current date for liveread or watchlist campaigns
    if(!lastSdoDate){
        endDates.push(new Date())
    }
    // Add end date of campaign
    if(campaign.endDate){
      endDates.push(new Date(campaign.endDate))
    }
    // Entire progress will be calculated based on the minimum of end dates
    const lastAvailableDate = new Date(Math.min.apply(null,endDates))
    const requestBody = {
        lastAvailableDate: lastAvailableDate.getTime(),
    };
    const percentageCalculated = yield getCalculatedPercentage(config.urlApi, campaign.campaign_id, requestBody);
    percentComplete = percentageCalculated.data ? percentageCalculated.data : 0;
    yield put(setCampaignProgressBarStatus(campaign.campaign_id, percentComplete));
}

export default function* campaign() {
    yield all([
        takeEvery(REMOVE_CAMPAIGN_SAGA, removeCampaignSaga),
        takeEvery(ADD_CAMPAIGN_SAGA, addCampaignSaga),
        takeEvery(DUPLICATE_CAMPAIGN_SAGA, duplicateCampaignSaga),
        takeEvery(UPDATE_CAMPAIGN_SAGA, updateCampaignSaga),
        takeEvery(GET_CAMPAIGN_SAGA, getCampaignSaga),
        takeEvery(UPDATE_CHART_DATA_CAMPAIGN_SAGA, updateCampaignChartData),
        takeEvery(GET_DETAIL_STATION_SAGA, getStationSaga),
        takeEvery(NEXT_STEP_CAMPAIGN_SAGA, nextStepSaga),
        takeEvery(REMOVE_CREATIVE_SAGA, removeCreativeSaga),
        takeEvery(UNDO_CREATIVE_NAME_SAGA, undoCreativeSaga),
        takeEvery(UPDATE_SUMMARY_DRILL_DOWN_SAGA, updateSummaryDrillDownSaga),
        takeEvery(GET_DATA_DRILL_DOWN_SAGA, getDataDrillDownSaga),
        takeEvery(UNDO_UPDATE_DATA_DRILLDOWN_SAGA, undoUpdateDrillDownSaga),
        takeEvery(MOVE_BACK_REASSIGN_SAGA, moveBackReassign),
        takeEvery(LOAD_ADPERFORMANCE_CHART_DATA_SAGA, loadAdperformanceChartDataSaga),
        takeEvery(LOAD_CAMPAIGN_DETAIL_SAGA, loadCampaignDetailSaga),
        takeEvery(CampaignAction.LOAD_GEOFENCE_DATA, loadGeoFenceDataSaga),
        takeEvery(LOAD_CAMPAIGN_PROGRESS_BAR_STATUS_SAGA, loadCampaignProgressBarStatusSaga),
        takeEvery(CampaignAction.LOAD_GEOFENCE_LOCATION_PATH, loadGeoFenceByLocationPathSaga),
    ]);
}
